import { useEffect } from "react";
import { requestForToken, onMessageListener } from "./global";

const useInitFcmRegisterProcess = (id, shop) => {
    useEffect(() => {
        //console.log("Registering FCM for", { id, shop });
        
        if (!id || !shop) return;

        const registerFcm = async () => {
            try {
                if (Notification.permission !== "granted") {
                    console.log("Notification permission not granted.");
                    return;
                }
        
                await requestForToken(id, shop);
        
                onMessageListener()
                    .then(payload => {
                        console.log("FCM Message received:", payload);
                    })
                    .catch(err => console.log("FCM listener error:", err));
            } catch (err) {
                console.error("FCM init error:", err);
            }
        };
        
        registerFcm();
    }, [id, shop]);
};

export default useInitFcmRegisterProcess;
